import OdfjellDatePicker from 'src/components/common/date-picker/OdfjellDatePicker';
import { InputProps } from '../OdfjellInputComponent';
import { getLuxonDateTime } from 'odfjell-date-time-utils/dateTimeUtils';

const DateInputComponent: React.FC<Partial<InputProps>> = ({ value, elementId, onDateInputChange }: Partial<InputProps>) => {
    if (value) {
        return (
            <OdfjellDatePicker
                format={'dd.MM.yyyy'}
                id={elementId}
                clearIcon={false}
                value={getLuxonDateTime(value)}
                placeholder={''}
                onChange={(date) => onDateInputChange({ date: date.toJSDate() })}
            />
        );
    }
    return (
        <OdfjellDatePicker
            format={'dd.MM.yyyy'}
            id={elementId}
            clearIcon={false}
            placeholder={''}
            onChange={(date) => onDateInputChange({ date: date.toJSDate() })}
        />
    );
};

export default DateInputComponent;
